<script setup>
   import { ref, watch, watchEffect, reactive, inject } from 'vue'
   import { useRoute } from 'vue-router'
   import { modalHide } from '@/composables/bootstrap'
   import { HIGHLIGHT_LANGUAGES } from '@/assets/static/highlight.static'

   const route = useRoute()

   const $storeGinnel = inject('$storeGinnel')
   const $storeCollections = inject('$storeCollections')

   const props = defineProps({
      action: {
         type: String,
         required: true
      },
   })

   const newCollection = ref('')
   const addCollection = () => {
      $storeCollections.add(newCollection.value)
      newCollection.value = ''
   }
</script>

<template>
   <Modal v-if="action == 'collection-modal'" id="collection-modal" size="medium">
      <template #header>New Collection</template>
      <template #body>
         <form @submit.prevent="addCollection()" class="cg-column-content">
            <div>
               <label for="collection-name" class="form-label label-required">Collection Name</label>
               <input id="collection-name" type="text" class="form-control" :class="{ 'is-valid': newCollection }" v-model="newCollection" placeholder="Collection Name" required>
            </div>

            <div class="d-flex justify-content-end">
               <PrimaryButton :disabled="! newCollection">
                  <template #label>Save Collection</template>
               </PrimaryButton>
            </div>
         </form>
      </template>
   </Modal>
</template>